import { render, staticRenderFns } from "./Lamborghini.vue?vue&type=template&id=1db268f5"
import script from "./Lamborghini.vue?vue&type=script&lang=js"
export * from "./Lamborghini.vue?vue&type=script&lang=js"
import style0 from "./Lamborghini.vue?vue&type=style&index=0&id=1db268f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports